import { Slider } from "antd";
import classNames from "classnames";
import isEqual from "lodash/isEqual";
import { useState, useEffect, useMemo } from "react";

import { ProgressBarSliderProps } from "./ProgressBar.type";

const MIN_VALUE = 0;
const MAX_VALUE = 100;

const ProgressBarSlider = ({
  value, // 0 or [0, 0] for range
  onChange,
  alwaysShowHandle = false,
  range = false,
}) => {
  const DEFAULT_VALUE = range ? [0, 0] : 0;

  const [stateValue, setStateValue] = useState(DEFAULT_VALUE);

  const onSliderChange = (value) => {
    setStateValue(value);
  };

  const onSliderAfterChange = (value) => {
    onChange?.(value);
  };

  const isSuccess = useMemo(() => {
    if (range) return false;
    return stateValue === MAX_VALUE;
  }, [range, stateValue]);

  const showHandle = useMemo(() => {
    if (range) return true;
    return alwaysShowHandle && value !== MAX_VALUE;
  }, [range, alwaysShowHandle, value]);

  useEffect(() => {
    const newValue = value ?? DEFAULT_VALUE;
    if (!isEqual(newValue, stateValue)) setStateValue(value);
  }, [value]);

  return (
    <div
      className={classNames("progress-bar-slider", {
        "-success": isSuccess,
        "-show-handle": showHandle,
      })}
    >
      {range && <span className="slider-text">{`${stateValue?.[0]}%`}</span>}
      <Slider
        min={MIN_VALUE}
        max={MAX_VALUE}
        value={stateValue}
        onChange={onSliderChange}
        onChangeComplete={onSliderAfterChange}
        tooltip={{ formatter: null }}
        range={range}
        classNames={{
          root: "progress-bar-slider--root",
          handle: "progress-bar-slider--handle",
          rail: "progress-bar-slider--rail",
          track: "progress-bar-slider--track",
        }}
      />
      <span className="slider-text">{`${stateValue?.[1] ?? stateValue}%`}</span>
    </div>
  );
};

ProgressBarSlider.propTypes = ProgressBarSliderProps;

export default ProgressBarSlider;
